import { Component, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';

import { NgxSpinnerService } from 'ngx-spinner';
import { GraphBar } from '../../_models/graph/GraphBar';
import { FundraisingReportService } from '../../_services/fundraising/fundraisingReport.service';
import { BreakdownType, Cue5050BaseReport, ReportType } from '../../_models/fundraising/reports/Cue5050BaseReport';
import { DatePipe } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SavedReportNamingModalComponent } from './saved-report-naming-modal.component';
import { Cue5050 } from '../../_models/fundraising/Cue5050';

@Component({
    selector: 'app-bar-graph-report',
    templateUrl: './bar-graph-report.component.html',
    styleUrls: ['./bar-graph-report.component.css']
  })

export class BarGraphReportComponent implements OnInit, OnDestroy{

    public colorBank = ["#fdb9c9", "#ffdcbe", "#f6f3b5", "#bbf6f3", "#a7e0f4", "#fdb9c9", "#ffdcbe", "#f6f3b5", "#bbf6f3", "#a7e0f4"]
    public events: Cue5050[] = [];

    public bars: GraphBar[] = [];
    public barData: Cue5050BaseReport[] = [];

    public reportType: ReportType;
    public reportTitle: string;

    public xAxis: string;
    public yAxis: string;

    public breakdownType: BreakdownType;
    public breakdownTypes: BreakdownType[] = [];
    public breakdown: string[] = [];
    public colors: string[] = [];

    public graphWidth = 80;
    public graphHeight = 40;

    public bsModalRef: BsModalRef;

    public showHeatmap = false;

    constructor (
        private reportService: FundraisingReportService,
        private router: Router,
        private route: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef,
        private datePipe: DatePipe,
        private modalService: BsModalService
    ){}

    ngOnInit(){
        this.spinner.show();
        this.events = this.reportService.eventsForReport;
        this.reportType = this.reportService.reportType;
        this.breakdownType = this.reportService.breakdownType;

        if (!this.events?.length || !this.reportType){
            this.goToWizardStart();
            return;
        }

        if (!this.breakdownType){
            this.breakdownType = this.getDefaultBreakdownType();
        }

        this.reportTitle = this.reportService.getReportTypeDescription(this.reportType);

        this.reportService.getBarData()
            .subscribe(data => {
                this.spinner.hide();
                this.barData = data;
                this.bars = this.reportService.getBarMappingByBreakdownType(this.breakdownType);
                this.breakdown = this.reportService.getBreakdownByBreakdownType(this.breakdownType);
                this.colors = [...this.colorBank].slice(0, this.breakdown.length);
                this.breakdownTypes = this.reportService.getBreakDownTypes();
                this.xAxis = this.reportService.getXAxisName();
                this.yAxis = this.reportService.getYAxisName();
            }, error => {
                this.spinner.hide();
                this.dialogService.alert('Uh Oh!', error, this.viewRef)
                    .then(_ => {
                        this.navigateUp();
                    });
            });
    }

    onBreakdownTypeChange(type: BreakdownType){
        try{
            this.breakdownType = type;
            this.bars = this.reportService.getBarMappingByBreakdownType(this.breakdownType);
            this.breakdown = this.reportService.getBreakdownByBreakdownType(this.breakdownType);
            this.colors = [...this.colorBank].slice(0, this.breakdown.length);
        } catch (err){
            this.dialogService.alert('Uh Oh!', err, this.viewRef)
                .then(_ => {
                    this.navigateUp();
                });
        }
    }

    downloadCSV(){
        let filename = this.reportType === ReportType.FinancialReport ? 'FinancialReport_' : this.reportType === ReportType.WhosPlaying ? "WhosPlaying_" : this.reportType === ReportType.PurchaseDetails ? "PurchaseDetails_" : "";
        this.reportService.getCSVReport(this.reportType, this.events.map(e => e.cue5050Id))
            .subscribe(res => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                var csvUrl = URL.createObjectURL(res);
                a.href =  csvUrl;
                a.download = filename + this.datePipe.transform(Date.now()) + ".csv";
                a.click();
                URL.revokeObjectURL(a.href)
                a.remove();
            }, error => {
                this.dialogService.alert("Uh oh!", "An error occured trying to generate a .csv file for this report.", this.viewRef);
            });
    }

    saveReport() {
        const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true
        };
    
        const initialState = {
          name: "New Report"
        };
    
        this.bsModalRef = this.modalService
          .show(
              SavedReportNamingModalComponent,
              Object.assign({}, modalConfig, { class: 'modal-sm', initialState })
          );

        this.bsModalRef.content.submitted
        .subscribe(name => {
            this.reportService.saveReport({ name: name, reportType: this.reportType, breakdownType: this.breakdownType, eventIds: this.events.map(e => e.cue5050Id)})
                .subscribe(_ => {
                    this.spinner.hide();
                    this.dialogService.alert("Success!", "That report was saved successfully, you will be able to view it any time from the 'Saved Reports' option at the beginning of the report wizard.", this.viewRef);
                }, error => {
                    this.spinner.hide();
                    this.dialogService.alert("Uh oh!", "Something went wrong trying to save that report.", this.viewRef);
                })
        });
    }

    getDefaultBreakdownType(){
        switch(this.reportType){
            case ReportType.FinancialReport:
                return BreakdownType.SalesByPaymentMethod;
            case ReportType.WhosPlaying: 
                return BreakdownType.PlayersByReturning;
            case ReportType.PurchaseDetails:
                return BreakdownType.OrdersByPaymentMethod;
            default:
                return null;
        }
    }

    goToWizardStart(){
        this.router.navigate([this.route.snapshot.url.pop().path === 'bar-graph' ? '../' : '../../'], {relativeTo: this.route});
    }

    navigateUp(){
        this.router.navigate(['../'], {relativeTo: this.route});
    }

    ngOnDestroy(){
        this.reportService.eventIds = [];
        this.reportService.reportType = null;
        this.reportService.breakdownType = null;
    }
}